import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Counter, WhyUs, ManifestLetter, Services, News, Partners } from '../../../sections';


const AboutUs = () => {
  return (
    <>

      {/* Page title */}
      <PageTitle title={'O nas'} page={'O nas'} />

      <section className='about-us'>

          <About />    {/* About section */}
          <WhyUs />    {/* Why Us section */}
          <News />     {/* Process section */}
          <Counter />  {/* Counter section */}
          <ManifestLetter/>
          <Services /> {/* Services section */}
          <Partners /> {/* Clients Section */}

      </section>

    </>
  );
}

export default AboutUs;